export const courses = {
  title: "Courses",
  subtitle: "Specialized training for educators, mothers and fathers",
  accompaniment: {
    title: "Accompaniment Course:",
    subtitle: "Accompanying girls and boys (2025-2026)",
    description: "Personal tools for the guide. The pleasure of learning through discovery.\n\nTraining course aimed at educators, mothers and fathers in which we will use a participatory methodology, with moments to reflect and share, dedicating much time to experiencing and practicing the skills related to each topic.",
    trainers: {
      title: "Trainers",
      names: "Tinus Wijnakker and Beatriz Aguilera Reija, founders of the Alavida school in Madrid with 25 years of experience."
    },
    duration: {
      title: "Duration",
      block1: "1st block: 24 hours",
      block2: "2nd block: 24 hours", 
      block3: "3rd block: 36 hours"
    },
    dates: {
      title: "Dates",
      block1: "1st block",
      block1Dates: "November 7-8 / November 28-29",
      block2: "2nd block", 
      block2Dates: "January 23-24 / February 20-21",
      block3: "3rd block",
      block3Dates: "March 27-28 / April 24-25 / May 22-23"
    },
    schedule: {
      title: "Schedule",
      friday: "Friday",
      fridayTime: "from 5:30 PM to 9:30 PM",
      saturday: "Saturday", 
      saturdayTime: "from 9:00 AM to 1:30 PM and from 3:00 PM to 6:30 PM"
    },
    location: {
      title: "Location",
      place: "Gándara International School"
    },
    capacity: {
      title: "Maximum capacity",
      block1: "First block: maximum capacity: 25 people",
      blocks23: "Second and Third block: maximum capacity: 30 people. (Participants from previous courses can also register)."
    },
    prices: {
      title: "Prices",
      fullEarly: "Full course (paying before October 10): €500",
      fullBlocks: "Full course (paying in three blocks): €160 + €160 + €240 = €560",
      block12: "Block 1 or 2 separately: €170",
      block3: "Block 3: €240",
      note1: "To participate only in block 3, it will be necessary to have previously taken some training with Tinus Wijnakker.",
      note2: "People who sign up for the entire course have preference."
    },
    content: {
      title: "COURSE CONTENTS:",
      blocks12: {
        title: "1st and 2nd block: Personal tools for the guide",
        instructor: "Led by Tinus Wijnakker",
        block1: {
          title: "Block 1 - 1st weekend (November 7-8)",
          topic: "Observation and communication processes:",
          point1: "How do we observe? And how does our way of observing affect us?",
          point2: "The importance of seeing and understanding communication signals.",
          point3: "Non-verbal and verbal communication",
          point4: "How to interpret messages from girls and boys?"
        },
        weekend2: {
          title: "2nd weekend (November 28-29)",
          topic: "Active listening:",
          point1: "Listening to understand and accompany.",
          point2: "The language of acceptance: Reflecting and accompanying.",
          point3: "Non-verbal communication and physical contact"
        }
      },
      block2: {
        title: "Block 2",
        weekend3: {
          title: "3rd weekend (January 23-24)",
          topic1: "Love and security:",
          point1: "Basic needs.",
          point2: "How does someone feel loved and secure?",
          point3: "Emotional support.",
          point4: "Listen, accept and accompany feelings.",
          topic2: "Freedom, limits and autonomy:",
          point5: "A relaxed environment.",
          point6: "Limits, coexistence rules and punishments.",
          point7: "Freedom and autonomy."
        },
        weekend4: {
          title: "4th weekend (February 20-21)",
          topic: "Conflictive situations:",
          point1: "Conflicts, aggressiveness and violence.",
          point2: "Analyze a conflictive situation.",
          point3: "Accompany to facilitate the regulation process."
        }
      },
      block3: {
        title: "Block 3: The pleasure of learning through discovery.",
        instructors: "Led by Beatriz Aguilera and Tinus Wijnakker",
        weekend5: {
          title: "5th weekend (March 27-28)",
          topic1: "Evolutionary stages:",
          point1: "Childhood: from 0 to 6 years: sensorimotor-affective stage",
          point2: "Childhood: from 6 to 12 years: concrete operations stage",
          topic2: "Prepared environments:",
          point3: "The corners.",
          point4: "The structures."
        },
        weekend6: {
          title: "6th weekend (April 24-25)",
          topic1: "The role of the adult:",
          point1: "The bond and emotional support",
          point2: "Guide and reference.",
          topic2: "Coexistence:",
          point3: "The process of personal and group relationships.",
          point4: "Responsibilities and autonomy.",
          point5: "Limits, coexistence rules and consequences.",
          point6: "Conflict situations."
        },
        weekend7: {
          title: "7th weekend (May 22-23)",
          topic: "The learning process:",
          point1: "How do girls and boys learn?",
          point2: "Social and emotional factors.",
          point3: "Curiosity and interest as learning engines",
          point4: "Autonomous learning",
          point5: "Presentations",
          point6: "Learning through discovery"
        }
      }
    }
  },
  psychomotricity: {
    title: "EDUCATIONAL PSYCHOMOTRICITY COURSE",
    subtitle: "\"Psychomotricity in early childhood education and first cycle of primary. Theory and resources for the classroom\"",
    dateTime: {
      title: "Date and Time",
      details: "October 25 from 10:00 AM to 5:00 PM at Gándara School in Gondomar."
    },
    price: {
      title: "Price",
      amount: "€60/person"
    },
    lunchNote: "There will be a lunch break, we recommend bringing a lunchbox with food and enjoying the space and company during this rest time.",
    content: {
      title: "Course content:",
      point1: "Body awareness work",
      point2: "Introduction to relational psychomotricity theory",
      point3: "Games and body dynamics to work in educational cycles 3-8 years",
      point4: "We will review the fundamental aspects of psychomotor practice",
      point5: "We will adapt the dynamics according to the educational needs of the people attending the training so that you have resources to use in classrooms",
      point6: "You will take home theory and practice texts to expand knowledge after training."
    }
  },
  contact: {
    title: "More information and registration",
    description: "For more information and/or registration:"
  }
};